import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import '../styles/About.css';

const About = () => {
  const highlights = [
    { id: 'tech-infra', text: 'Technical marketing infrastructure that actually converts' },
    { id: 'ai-segmentation', text: 'AI-driven segmentation & predictive personalization' },
    { id: 'mer-attribution', text: 'MER-focused attribution — beyond last-click' },
    { id: 'funnel-arch', text: 'Funnel architecture with zero tolerance for leakage' },
    { id: 'global-leadership', text: 'Global B2B & B2C campaign leadership' }
  ];

  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-image reveal">
            <div className="image-wrapper">
              <img 
                src="https://customer-assets.emergentagent.com/job_portfolio-growth-11/artifacts/zfqkde7o_My%20DP%20Square.JPG" 
                alt="Sanjib Roy"
                className="profile-image"
              />
              <div className="image-border"></div>
            </div>
          </div>
          
          <div className="about-text">
            <div className="section-label reveal">About Me</div>
            <h2 className="section-title reveal">Why Businesses Hire Me as Their Performance Marketing Consultant</h2>
            <div className="title-underline reveal"></div>
            
            <div className="about-description reveal">
              <p>
                I didn't become a performance marketing consultant to chase vanity metrics. I did it to understand how data actually turns into revenue. My goal is to bridge the gap between ad spend and profitable growth.
              </p>
              <p>
                With over 16 years of experience as a digital marketing consultant serving B2B and B2C brands globally, I focus on the technical infrastructure that makes campaigns successful. Based in Kolkata, India, I work remotely with businesses worldwide.
              </p>
              <p>
                As a growth marketing consultant, I leverage AI for predictive analytics, segmentation, and automated personalization to boost ROI in competitive markets. I focus strictly on ROI because, in this business,
                <strong> the numbers don't lie.</strong>
              </p>
            </div>
            
            <div className="callout-box reveal">
              <p className="callout-quote">
                "The gap between a click and a conversion is where most budgets bleed out."
              </p>
              
              <ul className="highlight-list">
                {highlights.map((item) => (
                  <li key={item.id} className="highlight-item">
                    <CheckCircle2 size={20} className="check-icon" />
                    <span>{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
